module.exports = __webpack_public_path__ + "static/media/sideBarExchange.e279c1d0.svg";